var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.949,
    height: 34,
    viewBox: "0 0 31.949 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_product_3407639",
    transform: "translate(-5.35 -2.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28595",
    "data-name": "Group 28595",
    transform: "translate(5.35 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16786",
    "data-name": "Path 16786",
    d: "M44.453,48.25,38.3,53.076l-3.251-2.561a2.485,2.485,0,0,0-2.724-.066,1.207,1.207,0,0,0-.088,2.036l4.613,3.644a2.233,2.233,0,0,0,1.406.46,2.325,2.325,0,0,0,1.406-.46l7.512-5.91a1.188,1.188,0,0,0-.088-2.036A2.232,2.232,0,0,0,44.453,48.25Z",
    transform: "translate(-23.379 -30.785)",
    fill: "#EB1700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16787",
    "data-name": "Path 16787",
    d: "M37.292,34.746,34.321,11.877a1.547,1.547,0,0,0-1.539-1.36H27.772V8.942a6.442,6.442,0,0,0-12.884,0v1.575H9.877a1.521,1.521,0,0,0-1.539,1.36L5.368,34.746a1.414,1.414,0,0,0,.394,1.217,1.6,1.6,0,0,0,1.181.537H35.753a1.478,1.478,0,0,0,1.181-.537A1.644,1.644,0,0,0,37.292,34.746ZM18.037,8.942a3.293,3.293,0,0,1,6.585,0v1.575H18.037ZM8.7,33.351l2.541-19.72H31.387l2.541,19.72Z",
    transform: "translate(-5.35 -2.5)",
    fill: "#EB1700"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.092a5539410874d991047a7f53b7cb9f.svg";
export { ForwardRef as ReactComponent };